'use client';

import React, { useContext, useState } from "react";
import Cookies from "js-cookie";
import "./index.css";
import { useNavigate, Link } from "react-router-dom";
import PatientContext from "../../context/PatientContext";
import { MdVisibilityOff, MdVisibility } from "react-icons/md";
import { ThreeCircles } from "react-loader-spinner";
import { RiContactsFill, RiLockPasswordFill } from "react-icons/ri";

const Login = (props) => {
  const { setLandingPage } = useContext(PatientContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isusernamestatus, setUsernameStatus] = useState(false);
  const [ispasswordstatus, setPasswordStatus] = useState(false);
  const [loginLoader, setLoginLoader] = useState(false);
  const [visibility, setPasswordVisible] = useState(false);
  const [loginError, setLoginError] = useState("");
  const navigate = useNavigate();

  const loginApiCall = async (userData) => {
    setLoginLoader(true);
    const LOGIN_URL = "https://clinical-server-apis.azurewebsites.net/login";

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(userData),
      redirect: "follow",
    };

    setLoginError("");

    let responseObj;
    try {
      const response = await fetch(LOGIN_URL, requestOptions);
      responseObj = await response.json();
    } catch (error) {
      setLoginLoader(false);
      setLoginError("Something went wrong. Please try again.");
      return;
    }

    if (responseObj.status !== "success") {
      setLoginLoader(false);
      setLoginError(responseObj.msg || "Login failed. Please try again.");
      return;
    }

    if (responseObj.status === "success") {
      Cookies.set("sas_token", responseObj.token_details.sas_token, {
        expires: 1,
        path: "/",
      });
      Cookies.set("jwt_token", responseObj.token_details.auth_token, {
        expires: 1,
        path: "/",
      });
      Cookies.set("login_details", JSON.stringify(responseObj.token_details), {
        expires: 1,
      });

      localStorage.setItem(
        "ContentFromAPI",
        JSON.stringify(responseObj.ContentFromAPI)
      );

      setLoginLoader(false);
      setLandingPage(responseObj.ContentFromAPI);
      props.updateToken(
        responseObj.token_details.auth_token,
        responseObj.token_details.sas_token
      );
      navigate("/");
    }
  };

  const updateUsername = (event) => {
    setUsername(event.target.value);
    setUsernameStatus(false);
  };

  const updatePassword = (event) => {
    setPassword(event.target.value);
    setPasswordStatus(false);
  };

  const ValidateUserDetails = (event) => {
    event.preventDefault();

    const userData = {
      username: username,
      password: password,
    };

    let allInputsFilled = true;
    let newStateValues = {};

    for (let key in userData) {
      if (userData[key] === "") {
        newStateValues["is" + key + "status"] = true;
        allInputsFilled = false;
      }
    }

    if (allInputsFilled) {
      loginApiCall(userData);
    } else {
      setUsernameStatus(newStateValues.isusernamestatus);
      setPasswordStatus(newStateValues.ispasswordstatus);
    }
  };

  const removeErrorMsg = () => {
    setLoginError("");
    setPasswordStatus(false);
    setUsernameStatus(false);
  };

  const showoff = () => {
    setPasswordVisible(!visibility);
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <Link to="/" className="header-logo">
            <img src="/logo.png" alt="Apollo Hospitals Logo" className="header-logo-img" />
            <span className="header-logo-text">Clinical AI</span>
          </Link>
          <div className="header-actions">
            <a href="mailto:clinicalailabs@apollohospitals.com" className="header-link">
              Get In Touch
            </a>
            <a href="#login" className="header-btn">
              Get Started
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title"> What we Offer </h1>
            <p className="hero-text">
              With several decades of clinical data, Apollo is developing powerful Clinical AI solutions that support smarter and faster decisions. These include risk scoring models that reduce hospitalizations, AI-driven decision support systems in critical care, and predictive tools that personalize treatment.
            </p>
            <p className="hero-text-small">
              Predict risk for chronic conditions such as AICVD, Prediabetes, Chronic Kidney Disease (CKD), exacerbation of Chronic Obstructive Pulmonary Disease (COPD) and liver fibrosis. These models are integrated into our health check programmes.
            </p>

            {/* Stats Grid */}
            <div className="stats-grid">
              <div className="stat-card">
                <p className="stat-value">20+</p>
                <p className="stat-label">AI Algorithms</p>
              </div>
              <div className="stat-card">
                <p className="stat-value">1.7M+</p>
                <p className="stat-label">Health Check Records</p>
              </div>
              <div className="stat-card">
                <p className="stat-value-small">ISO 13485 & MDSAP Certified</p>
              </div>
            </div>

            <div className="hero-actions">
              <a href="mailto:clinicalailabs@apollohospitals.com" className="hero-btn-primary">
                Get In Touch
              </a>
              <a href="#login" className="hero-btn-outline">
                Get Started
              </a>
            </div>
          </div>

          <div className="hero-image-container">
            <img src="/clinical-ai-hero.jpg" alt="Clinical AI - Advanced healthcare technology" className="hero-image" />
          </div>
        </div>
      </section>

      {/* Login Section */}
      <section className="login-section" id="login">
        <div className="login-section-header">
          <h2 className="login-section-title">Access Clinical AI Platform</h2>
        </div>
        <form className="login-form-container" onSubmit={ValidateUserDetails}>
          <h1 className="login-heading">Login</h1>
          <div className="label-with-input-container">
            <label className="input-label">Username</label>
            <div className="logo-with-input-continaer">
              <RiContactsFill className="auth-icons" />
              <input
                className="input-bar"
                type="text"
                placeholder="username"
                onChange={updateUsername}
                onFocus={removeErrorMsg}
              />
            </div>
            {isusernamestatus && (
              <p className="error-text">Please enter your Username</p>
            )}
          </div>
          <div className="label-with-input-container">
            <label className="input-label">Password</label>
            <div className="logo-with-input-continaer">
              <RiLockPasswordFill className="auth-icons" />
              <input
                className="input-bar"
                type={visibility ? "text" : "password"}
                placeholder="Password"
                onChange={updatePassword}
                onFocus={removeErrorMsg}
              />
              {visibility ? (
                <MdVisibility className="password-img" onClick={showoff} />
              ) : (
                <MdVisibilityOff onClick={showoff} className="password-img" />
              )}
            </div>
            {ispasswordstatus && (
              <p className="error-text">Please enter your Password</p>
            )}
          </div>
          <button className="login-button" type="submit">
            {loginLoader ? (
              <div className="login-loader-container">
                <ThreeCircles
                  height="30"
                  width="30"
                  color="white"
                  ariaLabel="three-circles-loading"
                  visible={true}
                />
              </div>
            ) : (
              "Login"
            )}
          </button>
          {loginError && (
            <p className="error-text mt-8 fw-500" role="alert">
              {loginError}
            </p>
          )}
        </form>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo">
            <img src="/logo.png" alt="Apollo Hospitals Logo" className="footer-logo-img" />
            <div className="footer-logo-text-container">
              <span className="footer-logo-text">Clinical AI</span>
              <p className="footer-logo-subtext">Apollo Hospitals</p>
            </div>
          </div>
          <div className="footer-links">
            <Link to="/privacy-policy" className="footer-link">
              Privacy Policy
            </Link>
          </div>
          <p className="footer-copyright">
            © {new Date().getFullYear()} Apollo Hospitals. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Login;
